<template>
  <div class="form-container">
    <v-card class="form-card" elevation="2">
      <!-- Cabeçalho -->
      <v-card-title class="form-header">
        <span class="form-title">{{ isEditMode ? 'Editar Exercício' : 'Cadastro de Exercício' }}</span>
        <v-checkbox
          v-model="formData.ativo"
          label="Ativo"
          color="primary"
          hide-details
          class="form-checkbox"
        />
      </v-card-title>

      <!-- Formulário -->
      <v-card-text class="form-content">
        <v-form ref="form" v-model="isFormValid">
          <!-- Linha 1: Exercício -->
          <v-row class="form-row">
            <v-col cols="12" sm="6" md="3" class="pa-1">
              <div class="form-label">Exercício</div>
              <v-text-field
                v-model="formData.exercicio"
                type="number"
                outlined
                dense
                :rules="[rules.required, rules.exercicio]"
                placeholder="Digite o exercício"
                class="form-field"
                hide-details="auto"
                maxlength="4"
                @input="validateExercicio"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <!-- Rodapé com Botões -->
      <v-card-actions class="form-actions">
        <v-btn
          @click="handleCancel"
          class="action-btn cancel-btn grey-btn"
        >
          Cancelar
        </v-btn>
        <v-btn
          @click="handleSave"
          color="primary"
          class="action-btn save-btn"
          :loading="isSaving"
        >
          <v-icon left>mdi-content-save</v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Snackbar para mensagens -->
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="3000"
      top
    >
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showSnackbar = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "ExercicioForm",
  props: {
    isEditMode: {
      type: Boolean,
      default: false
    },
    exercicioId: {
      type: [String, Number],
      default: null
    },
    initialData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        exercicio: '',
        ativo: true // Checkbox "Ativo" marcado por padrão
      },
      isFormValid: false,
      isSaving: false,
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: 'success',
      rules: {
        required: v => !!v || 'Por favor, preencha todos os campos obrigatórios',
        exercicio: v => {
          if (!v) return 'Campo obrigatório';
          const year = parseInt(v);
          const currentYear = new Date().getFullYear();
          if (v.length !== 4) return 'O exercício deve ter 4 dígitos';
          if (year < 1900 || year > currentYear + 10) return `O exercício deve estar entre 1900 e ${currentYear + 10}`;
          return true;
        }
      }
    };
  },
  mounted() {
    this.initializeForm();
  },
  watch: {
    initialData: {
      handler(newData) {
        if (newData && Object.keys(newData).length > 0) {
          this.initializeForm();
        }
      },
      immediate: true
    }
  },
  methods: {
    initializeForm() {
      if (this.initialData && Object.keys(this.initialData).length > 0) {
        this.formData = {
          exercicio: this.initialData.ano || this.initialData.exercicio || '',
          ativo: this.initialData.ativo !== undefined ? this.initialData.ativo : true
        };
      }
    },
    validateExercicio() {
      // Garantir que apenas números sejam inseridos e máximo 4 dígitos
      if (this.formData.exercicio) {
        this.formData.exercicio = this.formData.exercicio.replace(/\D/g, '').slice(0, 4);
      }
    },

    async handleSave() {
      if (!this.$refs.form.validate()) {
        this.showErrorMessage('Por favor, preencha todos os campos obrigatórios');
        return;
      }

      this.isSaving = true;
      
      try {
        // Emitir evento com dados do formulário
        this.$emit('save', {
          exercicio: this.formData.exercicio,
          ativo: this.formData.ativo
        });
        
      } catch (error) {
        console.error('Erro ao salvar:', error);
        this.showErrorMessage('Erro ao salvar Exercício');
      } finally {
        this.isSaving = false;
      }
    },
    
    handleCancel() {
      this.$emit('cancel');
    },
    
    resetForm() {
      this.formData = {
        exercicio: '',
        ativo: true // Manter checkbox "Ativo" selecionado
      };
      this.$refs.form.resetValidation();
    },
    
    showSuccessMessage(message) {
      this.snackbarMessage = message;
      this.snackbarColor = 'success';
      this.showSnackbar = true;
    },
    
    showErrorMessage(message) {
      this.snackbarMessage = message;
      this.snackbarColor = 'error';
      this.showSnackbar = true;
    }
  }
};
</script>

<style scoped>
@import '../../assets/styles/base-form.css';

/* Estilos específicos do ExercicioForm, se necessário */
</style>
